<!-- eslint-disable -->
<template>
</template>
<!-- eslint-enable -->
<script>
export default {
  created() {
    this.$socket.emit('desconectar', this.$store.getters.getSesion)
    var usuariosLogin = localStorage.getItem('usuariosLogin');
    var url = "/login"
    if (this.isSys4Conjunto()) {
      url += '/' + localStorage.getItem('instalacion')
    }
    localStorage.clear()
    localStorage.setItem('usuariosLogin',usuariosLogin);
    this.$store.reset()
    this.$router.push(url)
  },
};
</script>